import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { normalizeImageUrl } from "../../lib/imageUrl";
import PublicNav from "../../components/PublicNav";
import Footer from "../../components/Footer";
import Seo from "../../components/Seo";

const PLACEHOLDER = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'><rect width='4' height='5' fill='%23F0E8D8'/></svg>";

export default function About() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/public/home-settings").then(r => setS(r.data)).catch(() => {}); }, []);

  const heroImg = normalizeImageUrl(s?.about_hero_image) || normalizeImageUrl(s?.home_hero_image) || PLACEHOLDER;
  const sideImg = normalizeImageUrl(s?.about_side_image) || PLACEHOLDER;
  const eyebrow = s?.about_eyebrow || "About";
  const heroHeadline = s?.about_hero_headline || "An interactive mystery adventure across St. Petersburg.";
  const sectionEyebrow = s?.about_section_eyebrow || "Our story";
  const sectionHeadline = s?.about_section_headline || "Real streets. Real clues.";
  const body = s?.about_body || "";
  const ctaLabel = s?.about_cta_label || "Pick your mystery";

  return (
    <div className="public-shell">
      <Seo
        title="About"
        description={s?.about_hero_headline || "Mystery Served is an interactive mystery adventure across St. Petersburg, FL. Real streets, real clues, real fun."}
        url="https://mysteryserved.com/about"
      />
      <PublicNav overHero />
      <section className="relative h-[58vh] min-h-[400px] overflow-hidden bg-ms-cream" data-testid="about-hero">
        <img src={heroImg} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-transparent to-black/55" />
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-ms-cream via-ms-cream/85 to-transparent" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 h-full flex items-end pb-24">
          <div className="max-w-2xl animate-fade-up">
            <p className="label-eyebrow text-ms-brass-hi" style={{textShadow:'0 1px 12px rgba(0,0,0,0.4)'}}>{eyebrow}</p>
            <h1 className="serif text-white text-5xl md:text-7xl mt-4 leading-[0.95]" style={{textShadow:'0 2px 24px rgba(0,0,0,0.35)'}}>{heroHeadline}</h1>
          </div>
        </div>
      </section>

      <section className="bg-ms-cream py-24 md:py-32" data-testid="about-content">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-start">
          <div className="md:col-span-5">
            <img src={sideImg} alt="" loading="lazy" decoding="async" className="w-full aspect-[4/5] object-cover rounded-sm bg-ms-cream" />
          </div>
          <div className="md:col-span-7">
            <p className="label-eyebrow text-ms-brass">{sectionEyebrow}</p>
            <h2 className="serif text-ms-ink text-4xl md:text-5xl mt-5 leading-[1.05]">{sectionHeadline}</h2>
            <div className="mt-8 space-y-5 text-ms-stone text-base leading-[1.75] max-w-xl">
              {body.split(/\n\s*\n/).map((p, i) => <p key={i} className="whitespace-pre-line">{p}</p>)}
            </div>
            <Link to="/tours" className="btn-primary-dark mt-10 !py-3.5 !px-7" data-testid="about-cta">{ctaLabel}</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
